import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as moment from "moment";
import "moment-timezone";

import {
  setLoading as setCouponLoading,
  setCoupons,
  addCoupon,
  setEditingCouponId,
  updateCoupon,
  deleteCoupon,
  setError,
} from "../../features/common/couponSlice";
import { couponsList, deleteCouponById } from "../../services/userservice";
import ToasterMessage from "../../utils/ToasterMessage";

const Coupons = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const [toasterMessage, setToasterMessage] = useState('');
  const { coupons, loading, error } = useSelector((state) => state.coupon);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(setCouponLoading());
        const response = await couponsList();
        dispatch(setCoupons(response));
      } catch (error) {
        dispatch(setError(error.message));
      }
    };

    fetchData();
  }, [dispatch]);

  const handleDelete = async (couponId) => {
    // Here, you can prompt the user for confirmation before deleting
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      const deleteResponse = await deleteCouponById(couponId)
      if (deleteResponse.status === 200 || deleteResponse.status === 201) {
        dispatch(deleteCoupon(couponId));
        setShowToaster(true);
        setToasterMessage('Coupon deleted successfully!');
        setTimeout(() => {
          setShowToaster(false);
          setToasterMessage('');
        }, 3000)
      } else {
        //dispatch(setError(error.message))
        dispatch(setError(deleteResponse.message || 'Failed to delete coupon'));
      }

    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  if (loading) return <div>Loading...</div>; // Render a loading message

  if (error) return <div>Error: {error}</div>; // Render an error message

  const filteredCouponss = coupons.filter((coupon) =>
      coupon.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      coupon.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Table rows to show per page Start

  const indexOfLastItem = currentPage * rowsPerPage;
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  const filteredCoupons = filteredCouponss.slice(indexOfFirstItem, indexOfLastItem);

  // bottom pagination start

  const totalPages = Math.ceil(filteredCouponss.length / rowsPerPage);

  const renderPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 3;

    if (totalPages <= 10) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first 3 pages
      pages.push(1, 2, 3);

      // Show "..." if currentPage is beyond 5
      if (currentPage > 5) {
        pages.push("...");
      }

      // Show current page and neighbors
      const start = Math.max(4, currentPage - 1);
      const end = Math.min(totalPages - 3, currentPage + 1);

      for (let i = start; i <= end; i++) {
        if (!pages.includes(i)) pages.push(i);
      }

      // Show "..." if currentPage is far from end
      if (currentPage < totalPages - 4) {
        pages.push("...");
      }

      // Always show last 3 pages
      pages.push(totalPages - 2, totalPages - 1, totalPages);
    }

    return pages.map((page, index) => (
      <li
        key={index}
        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
      >
        {page === "..." ? (
          <span className="page-link">...</span>
        ) : (
          <button className="page-link" onClick={() => setCurrentPage(page)}>
            {page}
          </button>
        )}
      </li>
    ));
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <ToasterMessage className='float-end' show={showToaster} message={toasterMessage} onClose={() => setShowToaster(false)} />

        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              {/* <h1 className="m-0">Coupons</h1> */}
            </div>
            {/* /.col */}
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div classname="row">
            <div className="col-md-12">
              <div className="card">
                <div className="py-2 px-3 d-md-flex align-items-center  justify-content-between">
                  <h6 className="mr-md-0 mr-4">
                    <b>Coupons List</b>
                  </h6>
                  <div className="d-md-flex align-items-center justify-content-end">
                    <div className="mr-3 mb-2 mb-md-0">
                      <Link to="/add-coupons" className="btn btn-primary py-1">
                        <i className="fas fa-plus" /> Add Coupon
                      </Link>
                    </div>
                    <div
                      className="input-group input-group-sm"
                      style={{ width: "250px" }}
                    >
                      <input
                        type="text"
                        name="table_search"
                        className="form-control float-right"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <div className="input-group-append">
                        <button type="submit" className="btn btn-default">
                          <i className="fas fa-search" />
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="card-body">

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <label className="me-2">Show</label>
                      <select
                        value={rowsPerPage}
                        onChange={(e) => {
                          setRowsPerPage(parseInt(e.target.value));
                          setCurrentPage(1); // Reset to first page
                        }}
                        className="form-control mx-2 form-select d-inline-block w-auto"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ms-2">entries</span>
                    </div>
                    <div>
                      {/* Optional: Add search or pagination controls here */}
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Title</th>
                          <th>Coupons Code</th>
                          <th>Discount Type</th>
                          <th>Product</th>
                          <th>Discounts</th>
                          <th>Min Order Value</th>
                          <th>Max Order Value</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredCoupons.map((coupon) => (
                          <tr key={coupon.id}>
                            <td>{coupon.id}</td>
                            <td>{coupon.title}</td>
                            <td>{coupon.code}</td>
                            <td>{coupon.discountType}</td>
                            <td>{coupon.applicableTo}</td>
                            <td>{coupon.discount}</td>
                            <td>{coupon.min_order_value}</td>
                            <td>{coupon.max_order_value}</td>
                            <td>
                              {moment(coupon.validFrom).format("DD-MM-YYYY")}
                              {/* {moment
                              .utc(coupon.validFrom)
                              .tz("Asia/Kolkata")
                              .format("DD-MM-YYYY")} */}
                            </td>
                            <td>
                              {moment(coupon.validUntil).format("DD-MM-YYYY")}
                            </td>
                            <td>
                              <span
                                className={`badge p-2 w-100 ${coupon.status === "active"
                                  ? "badge-success"
                                  : "badge-danger"
                                  }`}
                              >
                                {coupon.status.toUpperCase()}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                <Link to={`/edit-coupons/${coupon.id}`}>
                                  <button className="btn btn-primary btn-sm">
                                    Edit
                                  </button>
                                </Link>
                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(coupon.id)}>
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-md-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCouponss.length)} of {filteredCouponss.length} entries
                    </div>
                    <nav>
                      <ul className="pagination mb-0">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                            Previous
                          </button>
                        </li>

                        {renderPageNumbers()}

                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>

  );
};

export default Coupons;
